export default {
  title: '前员工管理',
  menu: '前员工管理',
  label: {
    email: '邮箱',
    phone: '手机',
    name: '姓名',
    status: '状态',
    Active: '已加入人才库',
    InActive: '未加入人才库',
    excelInput: 'EXCEL文件: ',
    Pending: '待定',
    addAlumni: '新增前员工',
    editAlumni: '编辑前员工',
    birthday: '生日',
    isEnabled: '是否启用'
  },
  placeholder: {
    email: '请输入邮箱',
    phone: '请输入手机',
    name: '请输入姓名',
    birthday: '请选择生日'
  },
  btn: {
    selectFile: '浏览',
    upload: '上传前员工',
    downloadTemplate: '下载模板',
    fleshData: '刷新',
    cancelUpload: '取消',
    ConfirmUpload: '确认',
    addAlumni: '添加前员工'
  },
  message: {
    uploadTip: '只能上传excel文件',
    uploadError: '上传失败,请重新上传',
    uploadSuccess: '上传成功{successCount}条， 失败{failCount}条',
    refreshSuccess: '刷新前员工数据成功',
    refreshError: '今天已经刷新过，请明天再试',
    refreshTip: '前员工数据发生改变后，将在0点自动更新。',
    missEmailOrPhone: '邮箱和手机至少填写一个',
    optionSuccess: '操作成功',
    optionField: '操作失败',
    alumniIsExisted: '邮箱或手机已存在'
  }
}
